// extracted by mini-css-extract-plugin
export default {"container":"ProjectsActionsComponent_container__Ml6r9"};